import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';

import { SymbolLookupDataSource } from '../../../domain/symbol-lookup.domain';
import { SymbolLookupService } from '../../../features/symbol-lookup/symbol-lookup.service';
import { Account } from '../../../domain/account.domain';

@Injectable()
export class PositionLookupDataSourceService implements SymbolLookupDataSource {
  private readonly symbolLookupService = inject(SymbolLookupService);

  private fromAccount: Account;
  private transferToken: string;
  private contributionType: string;

  create(fromAccount: Account, transferToken: string, contributionType: string): SymbolLookupDataSource {
    this.fromAccount = fromAccount;
    this.transferToken = transferToken;
    this.contributionType = contributionType;
    return this;
  }

  search<T>(symbolQuery: string, maxResults: number): Observable<Array<T>> {
    if (symbolQuery !== undefined) {
      return this.symbolLookupService
        .queryPositionSymbols(this.fromAccount.id, symbolQuery, maxResults, this.transferToken, this.contributionType);
    }
    return of([]);
  }
}

